import { render, staticRenderFns } from "./McmSidebarLayout.vue?vue&type=template&id=2d2dcf86&scoped=true"
import script from "./McmSidebarLayout.vue?vue&type=script&lang=ts"
export * from "./McmSidebarLayout.vue?vue&type=script&lang=ts"
import style0 from "./McmSidebarLayout.vue?vue&type=style&index=0&id=2d2dcf86&prod&lang=scss&scoped=true"
import style1 from "./McmSidebarLayout.vue?vue&type=style&index=1&id=2d2dcf86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2dcf86",
  null
  
)

export default component.exports